import * as React from "react";
import { ParagraphNode } from "--root/static_types/slate/Shared";
import styled from "styled-components";
import { RenderElementPropsT } from "../../utils";

const P = styled.p`
    ${props => props.theme.typography.body1};
    :last-of-type { margin-bottom: 0; }
`;

export const ParagraphBlock: React.FC<RenderElementPropsT<ParagraphNode>> = (props) => {
    return <P {...props.attributes} >
        {props.children}
    </P>
}